import React from 'react';
import { FiMail, FiPhone, FiMapPin, FiClock, FiFacebook, FiTwitter, FiInstagram, FiLinkedin, FiGlobe } from 'react-icons/fi';
import './Footer.css'; // Import the CSS file

const Footer = () => {
  const quickLinks = [
    { name: 'Home', href: '#home' },
    { name: 'Features', href: '#features' },
    { name: 'Streams', href: '#streams' },
    { name: 'Benefits', href: '#benefits' },
    { name: 'Timeline', href: '#timeline' },
  ];

  const socialLinks = [
    { icon: <FiInstagram />, href: 'https://www.instagram.com/dylora_solutions', label: 'Instagram' },
    { icon: <FiLinkedin />, href: 'https://linkedin.com/company/dylora', label: 'LinkedIn' },
  ];

  const contactInfo = [
    { icon: <FiMail />, text: 'contact@dylora.in' },
    { icon: <FiPhone />, text: '+91 70212 88082' },
    { icon: <FiMapPin />, text: 'Chembur, Mumbai' },
    { icon: <FiGlobe/>, text: 'www.dylora.in' },
    // { icon: <FiClock />, text: 'Mon - Fri: 9:00 AM - 6:00 PM' },
  ];

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Main Footer Content */}
        <div className="main-content">
          {/* Logo and Description */}
          <div className="logo-section">
            <div className="footer-logo">
              <span className="logo-text" style={{ color: 'white' }}>DYLORA</span>
              {/* <span className="logo-accent">PRO</span> */}
            </div>
            <p className="footer-description">
              Transforming students into industry-ready professionals through our 
              1+1 Internship Program. Get trained, gain experience, and launch your career.
            </p>
            <div className="social-links">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  className="social-link"
                  aria-label={social.label}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div className="links-section">
            <h3 className="section-title" style={{ color: 'white' }}>Quick Links</h3>
            <ul className="links-list">
              {quickLinks.map((link) => (
                <li key={link.name} className="link-item">
                  <a href={link.href} className="footer-link">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="contact-section">
            <h3 className="section-title" style={{ color: 'white' }}>Contact Us</h3>
            <div className="contact-list">
              {contactInfo.map((info, index) => (
                <div key={index} className="contact-item">
                  <div className="contact-icon">{info.icon}</div>
                  <span className="contact-text">{info.text}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Newsletter */}
          {/* <div className="newsletter-section">
            <h3 className="section-title">Stay Updated</h3>
            <p className="newsletter-text">
              Subscribe to get updates on new batches and opportunities
            </p>
            <div className="newsletter-form">
              <input
                type="email"
                placeholder="Enter your email"
                className="newsletter-input"
              />
              <button className="newsletter-button black-btn">
                Subscribe
              </button>
            </div>
          </div> */}
        </div>

        {/* Divider */}
        <div className="footer-divider" />

        {/* Bottom Bar */}
        <div className="bottom-bar">
          <div className="copyright">
            © {new Date().getFullYear()} DYLORA. All rights reserved.
          </div>
          <div className="legal-links">
            <a href="/privacy" className="legal-link">Privacy Policy</a>
            <a href="/terms" className="legal-link">Terms & Conditions</a>
            <a href="/refund" className="legal-link">Refund Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;